<template>
  <div>
    <div
      class="items-center hidden ml-3 md:flex private-mode-container"
      :class="{'cursor-pointer': !isDisableEditPresentation}"
      @click="switchPrivateMode()"
      v-if="!isGuestUser"
    >
      <aha-spinner
        class="w-6 h-6"
        :variant="isBackstage ? 'white' : 'dark'"
        v-if="isSwitchingPresentationMode"
      />
      <PrivateModeButton v-else :presentation="presentation" />
    </div>
    <ModalPresentingPrivateMode
      v-if="isModalPresentingPrivateModeVisible"
      @hideModal="isModalPresentingPrivateModeVisible = false"
      openFrom="Backstage"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PrivateModeButton from '@/components-v2/presentation-editor/editor-header/PrivateModeButton.vue'
import ModalPresentingPrivateMode from '@/components-v2/modals/PresentingPrivateMode.vue'

export default {
  components: {
    PrivateModeButton,
    ModalPresentingPrivateMode,
  },
  props: {
    isSwitchingPresentationMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isModalPresentingPrivateModeVisible: false,
  }),
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      isGuestUser: (state) => state.currentUser.isGuest,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    switchPrivateMode() {
      if (!this.isBackstage) {
        this.$emit('switchPrivateMode')
        return
      }
      this.isModalPresentingPrivateModeVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.private-mode-container {
  margin-left: 0.5rem;
}
</style>
